export const ACTION_SAVE_USERS_PAGINATED = 'ACTION_SAVE_USERS_PAGINATED';
export const ACTION_SAVE_USER_DETAILS = 'ACTION_SAVE_USER_DETAILS';
export const ACTION_SAVE_USER_TYPE = 'ACTION_SAVE_USER_TYPE';
export const ACTION_CLEAN_USER = 'CLEAN_USER';
export const ACTION_SAVE_USER_BALANCE = 'ACTION_SAVE_USER_BALANCE';
